import { Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { BASIC_INFO_FORM_TYPE } from '../../../person/detailsPage/editComponents/BasicInfoFormUtils';
import { SECURITY_ACTIONS } from '../../auth/Security';
import type { SecuredActionType } from '../../components/ActionType';
import EllipsisText from '../../components/EllipsisText';
import ResponsiveActions from '../../components/ResponsiveActions';
import { ENTITY_CONSTANTS } from '../../constants/entityConstants';
import I18n from '../../i18n/I18n';
import { Icons } from '../../icons/Icons';
import { H, V } from '../../Layout';
import { useStyling } from '../../Theme';

export default function RolesAndTypesSection({
    id,
    professionalRoles,
    organizationTypes,
    editEnabled = undefined,
    onEdit = undefined,
    isOrganizationProfile = false,
    handleEditOrganization = undefined
}) {
    const { theme, isMobile } = useStyling();
    const [addRoles, setAddRoles] = useState(false);

    const securedActions = useMemo<SecuredActionType[]>(
        () => [
            {
                securityAction: SECURITY_ACTIONS.EDIT,
                entityName: isOrganizationProfile ? ENTITY_CONSTANTS.organization : ENTITY_CONSTANTS.person,
                label: <I18n token="form.title.add" />,
                icon: Icons.AddButton,
                onClick: () => {
                    isOrganizationProfile ? handleEditOrganization?.() : onEdit?.(BASIC_INFO_FORM_TYPE.roles);
                }
            }
        ],
        [handleEditOrganization, isOrganizationProfile, onEdit]
    );

    return (
        <V onMouseEnter={() => setAddRoles(true)} onMouseLeave={() => setAddRoles(false)}>
            <H sx={{ height: isMobile ? '45px' : '25px', justifyContent: isMobile && 'space-between' }}>
                <Typography color={theme.palette.text.secondary}>
                    <I18n token={id} />
                </Typography>
                {editEnabled && (
                    <ResponsiveActions
                        isActivated={addRoles}
                        securedActions={securedActions}
                        containerSx={{ p: 0 }}
                    />
                )}
            </H>
            {professionalRoles || organizationTypes ? (
                <H data-testid={`${id === 'Organization type' ? 'organization-types' : 'professional-roles'}`}>
                    <EllipsisText text={professionalRoles?.join(', ') || organizationTypes?.join(', ')} />
                </H>
            ) : (
                <H
                    data-testid={`${id === 'Organization type' ? 'organization-types' : 'professional-roles'}`}
                    sx={{ color: theme.palette.text.disabled, width: 'fit-content' }}
                >
                    <EllipsisText text={<I18n token="no.data.added" />} />
                </H>
            )}
        </V>
    );
}
